import { render, staticRenderFns } from "./scenic-spot.vue?vue&type=template&id=42860afb&scoped=true&"
import script from "./scenic-spot.vue?vue&type=script&lang=js&"
export * from "./scenic-spot.vue?vue&type=script&lang=js&"
import style0 from "./scenic-spot.vue?vue&type=style&index=0&id=42860afb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42860afb",
  null
  
)

export default component.exports